import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "./AuthContext";
import { isSuperAdminUser, permissionHas, resolveUserPermissionCodes } from "../Utils/Permissions";

export default function ProtectedRoute({ requiredRoles, requiredPermission }) {
  const { token, decodedToken, permissions, logout } = useAuth();

  if (!token) {
    return <Navigate to={"/"} replace />;
  }

  let decoded;
  try {
    decoded = decodedToken || jwtDecode(token);
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      Promise.resolve().then(logout);
      return <Navigate to={"/"} replace />;
    }
  } catch {
    Promise.resolve().then(logout);
    return <Navigate to={"/"} replace />;
  }

  const isSuperAdmin = isSuperAdminUser(decoded);

  if (requiredRoles && !isSuperAdmin) {
    const userRole = (decoded?.role || "").toLowerCase();
    const allowedRoles = requiredRoles.map((r) => r.toLowerCase());
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/restricted" replace />;
    }
  }

  if (requiredPermission) {
    const userPermissions = resolveUserPermissionCodes({ permissions, decodedToken: decoded });
    const requiredList = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
    const hasAccess = requiredList.some((perm) => permissionHas(userPermissions, perm, decoded));
    if (!hasAccess) {
      return <Navigate to="/restricted" replace />;
    }
  }

  return <Outlet />;
}

